import { defineStore } from 'pinia'
import { mergeOptionsParams, useCreateForm, useEditForm } from "@/stores/_helpers.js";
import toasteventbus from "primevue/toasteventbus";

export const useRxSWINStore = defineStore('rxSWIN', {
  state: () => ({
    data: undefined,
    options: undefined,
    lastRequestId: 0,
  }),
  getters: {
    getRxSWINs: (state) => state.data?.data,
    getRxSWINOptions: (state) => state.options?.data,
  },
  actions: {
    /**
     * This method should be used to return as little data as possible for use in select boxes
     *
     * @param silent
     * @param params
     * @returns {Promise<any>}
     */
    async indexRxSWINOptions(params = {}, silent = true) {

      const requestId = (++this.lastRequestId);

      if (!silent)
        this.options = undefined;

      try {
        if (!this.options) {
          let qryParams = mergeOptionsParams(params, 'rx-swins', ['id','name','company_id']);
          const response = await axios.get('rx-swins', {params: qryParams});
          if (requestId === this.lastRequestId) { // discard out of date data
            this.options = response.data;
          }
        }

        return this.options;
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async indexRxSWINs(params = {}) {
      try {
        const response = await axios.get('rx-swins', {params});
        this.data = response.data;
        return response.data;
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async showRxSWIN(rxSWINId, params = {}) {
      try {
        const response = await axios.get(`rx-swins/${ rxSWINId }`, {params});
        return response.data;
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
  },
});
